import './index.css';

export const TextArea = ({ label, placeholder, value, onChange, disabled = false, maxLength = 1000, textAreaStyle }) => {

  const handleChange = (e) => {
    onChange(e.target.value);
  }

  return (
    <div className={`text-area-container ${disabled ? 'text-area-container-disabled' : ''}`}>
      <span className="text-area-container-label">{label}</span>
      <textarea className="text-area-container-textarea" style={textAreaStyle} placeholder={placeholder} value={value} onChange={handleChange} disabled={disabled} />
      <span className="text-area-container-counter">{value ? value.length : 0}/1000</span>
    </div>
  );
};